export default function Light() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_11523)">
                <path
                    d="M12.369 23.5934C12.4125 24.3842 13.0616 25 13.8535 25H18.1309C18.9276 25 19.5787 24.3769 19.6187 23.5812C19.7312 21.341 19.9847 18.4719 21.3733 17.1149C22.7405 15.7848 23.5041 13.9971 23.5 12.1366C23.5 8.20157 20.1358 5 16.0002 5C11.8518 5 8.55766 8.09091 8.501 12.0364C8.48491 12.969 8.66226 13.8954 9.02292 14.7627C9.38358 15.63 9.92045 16.4212 10.6028 17.0908C11.991 18.4594 12.2454 21.3458 12.369 23.5934Z"
                    stroke="black"
                    strokeWidth="1.5"
                />
                <path d="M18 25.5C18 26.6046 17.1046 27.5 16 27.5C14.8954 27.5 14 26.6046 14 25.5" stroke="black" strokeWidth="1.5" />
                <line x1="12" y1="22.25" x2="20" y2="22.25" stroke="black" strokeWidth="1.5" />
                <path d="M6 11H4" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M26 10.7072H28" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6.70703 7.70703L5.29282 6.29282" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M25.293 7.41418L26.7072 5.99997" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M6.70703 14L5.29282 15.4142" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M25.293 13.7072L26.7072 15.1214" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M15 15.5H17.5V21.5H15V15.5Z" stroke="black" />
                <path
                    d="M17.5 14.5C17.5 13.9477 17.9477 13.5 18.5 13.5C19.0523 13.5 19.5 13.9477 19.5 14.5C19.5 15.0523 19.0523 15.5 18.5 15.5H17.5V14.5Z"
                    stroke="black"
                />
                <path d="M15 14.5C15 13.9477 14.5523 13.5 14 13.5C13.4477 13.5 13 13.9477 13 14.5C13 15.0523 13.4477 15.5 14 15.5H15V14.5Z" stroke="black" />
            </g>
            <defs>
                <clipPath id="clip0_10719_11523">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
